import { render, staticRenderFns } from "./WBtnUnarchive.vue?vue&type=template&id=620e3c2c&scoped=true&"
import script from "./WBtnUnarchive.vue?vue&type=script&lang=js&"
export * from "./WBtnUnarchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620e3c2c",
  null
  
)

export default component.exports